var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "training-courses__wrapper" }, [
    _c(
      "div",
      { staticClass: "training-courses" },
      [
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showSelectedCourse,
              expression: "showSelectedCourse",
            },
          ],
          staticClass: "overlay",
          on: {
            click: function ($event) {
              _vm.showSelectedCourse = false
            },
          },
        }),
        _vm._v(" "),
        _vm._l(_vm.courses, function (course) {
          return _c(
            "div",
            {
              key: course.id,
              staticClass: "training-courses training-courses__course",
              attrs: { "data-id": course.id },
            },
            [
              _c("div", {
                staticClass: "training-courses__image",
                style: `background: url(${course.acf.intro_image.sizes.medium_large}) no-repeat center center / cover`,
              }),
              _vm._v(" "),
              _c("h3", [_vm._v(_vm._s(course.title.rendered))]),
              _vm._v(" "),
              _c("div", {
                staticClass: "training-courses training-courses__content",
                domProps: {
                  innerHTML: _vm._s(_vm.shorten(course.acf.intro_text)),
                },
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "button button__mid-grey",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.selectCourse(course)
                    },
                  },
                },
                [_vm._v("See more")]
              ),
              _vm._v(" "),
              _vm.selectedCourse.id == course.id && _vm.showSelectedCourse
                ? _c("div", { staticClass: "training-courses__course--marker" })
                : _vm._e(),
            ]
          )
        }),
      ],
      2
    ),
    _vm._v(" "),
    _vm.showSelectedCourse
      ? _c(
          "div",
          {
            staticClass: "training-courses__popup dark_info_sec",
            style: _vm.PopupStyle,
          },
          [
            _c(
              "span",
              {
                staticClass: "training-courses__popup--close",
                on: {
                  click: function ($event) {
                    _vm.showSelectedCourse = false
                  },
                },
              },
              [_vm._v("×")]
            ),
            _vm._v(" "),
            _c("h2", [
              _vm._v(
                _vm._s(_vm.selectedCourse.title.rendered) + " Course Details"
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "training-courses__popupcontentwrapper" },
              [
                _c("div", {
                  staticClass: "image",
                  style: `background: url(${_vm.selectedCourse.acf.intro_image.sizes.medium_large}) no-repeat center center / cover`,
                }),
                _vm._v(" "),
                _c("div", { staticClass: "training-courses__popupcontent" }, [
                  _c("div", {
                    domProps: {
                      innerHTML: _vm._s(_vm.selectedCourse.acf.intro_text),
                    },
                  }),
                  _vm._v(" "),
                  _vm.selectedCourse.acf != _vm.undefines &&
                  _vm.selectedCourse.acf.training_modules
                    ? _c("h3", [_vm._v("Training Modules")])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "ul",
                    _vm._l(
                      _vm.selectedCourse.acf.training_modules,
                      function (mod, index) {
                        return _c("li", { key: index }, [
                          _c("strong", [_vm._v(_vm._s(mod.post_title))]),
                        ])
                      }
                    ),
                    0
                  ),
                  _vm._v(" "),
                  _vm._m(0),
                ]),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c(
        "a",
        {
          staticClass: "button button__white button-white",
          attrs: { href: "/training-grounds-enquiry" },
        },
        [_vm._v("Enquire Now")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/components/TrainingCourses.vue